import { render, staticRenderFns } from "./SidebarSecondaryList.vue?vue&type=template&id=a15eb760&"
import script from "./SidebarSecondaryList.vue?vue&type=script&lang=js&"
export * from "./SidebarSecondaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports